
import ReactDOM from 'react-dom';
import {AppLink as Link, AppWrapper, ClonePages, AppPages, EditInfo} from "../components/helpers";
import app from "../components/app";
import Editor from "./editor";
import Preview from "./preview";
import {addNewProperty} from "./masterBlocks"

import { useEffect, useState } from "react";

const copyClipboard = function(copyText) {
    var input = document.createElement("input");
    input.value = copyText;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    alert("Copied: " + copyText);
}


const openPopup = function(data, callback){
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<AppPages data={data} callback={callback} />, div);
}

const clonePopup = function(data, callback){
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<ClonePages data={data} callback={callback} />, div);
}

const editPopup = function(data, callback){
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<EditInfo data={data} callback={callback} />, div);
}

export default function Pages(props) {
    const [data, setData] = useState([]);
    const [item, setItem] = useState(null);
    const [page, setPage] = useState("");
    const [type, setType] = useState("");
    const config = app.getConfig();
    
    useEffect(() => {
        if(props.category) {
            app.fetchPost({
                "method":"getAllPages",
                //"lang":"en",
                "id":props.category
            }).then(function(response){
                let itemData = null;
                if(response.data) {
                    response.data.forEach(function(v){
                        if(v.id === props.category) {
                            itemData = JSON.parse(JSON.stringify(v))
                        }
                    });
                    if(itemData) {
                        itemData["data"] = JSON.parse(itemData["data"]);
                        itemData["data"] = itemData["data"].map(function(v, i){
                        // if(v.widgetType == "website_two"){
                        //     return addNewProperty(v)
                        // } 
                        // if(v.widgetType == "home_photo_gallery"){
                        //     return addNewProperty(v)
                        // } 
                            return v
                         })
                        itemData["dynamicAIData"] = itemData["data"];
                        setItem(itemData);
                        console.log("itemData", itemData)
                    }
                }
            })
        }
        else {
            app.fetchPost({
                "method":"getAllPages",
                "lang":"en"
            }).then(function(response){
                if(response.data) {
                    setData(response.data);
                }
            })
        }
    }, [props.category]);

    const updateItem = function(key, value) {
        let itemData = JSON.parse(JSON.stringify(item));
        itemData[key] = value;
        setItem(itemData);
    }

    const saveItem = function(item, mode) {
        const postData = {
            "method":"savePages",
            "title":item.title,
            "page":item.page,
            "category":item.category,
            "status":item.status,
            "data":JSON.stringify(item.data)
        }
        if(item.id) {
            postData["id"] = item.id;
        }
        app.fetchPost(postData, mode).then(function(response){
            if(!item.id) {
                if(response.data._id) {
                    window.pushState("pages", response.data._id);
                }
                else {
                    //window.location.reload();
                }
            }
          //  console.log("response", response);
        })
    }
    const deleteItem = function(index) {
        if(window.confirm("do you really want to delete this Page")) {
            app.fetchPost({
                "method":"deletePages",
                "id":data[index].id
            }).then(function(){
                setData(data.filter(function(v, i){
                    if(i === index) {
                        return false;
                    }
                    return true;
                }))
            })
        }
    }
    const cloneItem = function(index) {
        app.getPage(data[index].id, function(response){
            clonePopup(response, function(response){
              //  console.log(response);
            })
        })
    }
    const editInfo = function(index) {
        const nextData = JSON.parse(JSON.stringify(data));
         editPopup(nextData[index], function(response){
            nextData[index] = response;
            setData(nextData);
          //  console.log(response);
        })
        // app.getPage(data[index].id, function(response){
        //     console.log(data[index]);
        //     // editPopup(response, function(response){
        //     //     data[index] = response;
        //     //     setData(data);
        //     //   //  console.log(response);
        //     // })
        // })
    }
    
    const defaultItem = function(index) {
        //{"method":"addIdentifierInPage","aiPageId":"65533bdf961e425f01267724","aiPageIdenfier":"website"}

        app.fetchPost({
            "method":"addIdentifierInPage",
            "aiPageId":data[index].id,
            "aiPageIdenfier":"website"
        }).then(function(response){
             console.log("response", response)
        })
    }

    let html = <div className="w-100 p-2">
    <button className="btn btn-lg btn-outline-success" onClick={() => openPopup(null, saveItem)}>Add Page</button>
    </div>
    if(props.subcategory) {
        if(props.subcategory === "preview") {
            return <Preview type="pages" id={props.category} />
        }
        html = <div className="w-100 p-2">No Preview Found</div>
    }
    else if(props.category) {
        if(item) {
            return <Editor data={item} type="pages" callback={function(value, mode){
                let itemData = JSON.parse(JSON.stringify(item));
                itemData["data"] = value.dynamicAIData;
                saveItem(itemData, mode);
            }} />
        }
        html = <div className="w-100 p-2">Loading</div>
    }
    else {
        if(data.length) {
            html = <div className="container pages-container p-0">
                
            <div className="row">
                {
                    data.map(function(v, i){
                        let status = <span className="badge bg-danger">inactive</span>
                        if(v.status) {
                            status = <span className="badge bg-success">active</span>
                        }
                        if(page !== "") {
                            if(page !== v.page) {
                                return false;
                            }
                        }
                        if(type !== "") {
                            if(type !== v.category) {
                                return false;
                            }
                        }
                        let title = v.title;
                        if(v.heading) {
                            if(v.heading !== "") {
                                title = v.heading;
                            }
                        }
                        const copyJson = {
                            id:v.id,
                            title,
                            page:v.page
                        }
                        return  <div className="col-3 mb-4" key={`page-${i}`} id={v.page+'-'+v.id}>
                        <div className="card w-100">
                        <img src={`${window.aiHost}/images/image-1x1.png`} className="card-img-top" alt="..." style={{backgroundImage:`url(https://media.mediadirhub.com/layouts/website/en/${v.id}.png?version=${window.aiVersion})`}} />
                        <div className="card-body">
                            <h5 className="card-title">{v.title}</h5>
                            <div>
                                <span className="badge bg-primary me-1">{v.page}</span> 
                                <span className="badge bg-secondary me-1">{v.category}</span> 
                                {status}
                            </div>
                         
                        </div>
                        <div className="card-footer p-1">
                            <a href={`/pages/${v.id}`} className="btn btn-sm btn-secondary m-1">Edit</a>
                            <button className="btn btn-sm btn-primary m-1" onClick={() => editInfo(i)}>Edit Info</button>
                            <button href={`/pages/${v.id}`} className="btn btn-sm btn-info m-1" onClick={() => cloneItem(i)}>Clone</button>
                            <button type="button" className="btn btn-sm btn-danger m-1 d-none" onClick={() => deleteItem(i)}>Delete</button>
                            <Link href={`/pages/${v.id}/preview`} className="btn btn-sm btn-secondary m-1">Preview</Link>
                            <button type="button" className="btn btn-sm btn-dark m-1" onClick={() => defaultItem(i)}>Default</button>
                            <Link href={`/pages/${v.id}/lang`} className="btn btn-sm btn-secondary m-1">Convert</Link>
                            <button className="btn btn-sm btn-secondary" type="button" onClick={() => copyClipboard(JSON.stringify(copyJson))}>copy JSON</button>
                        </div>
                        </div>
                    </div>
                    })
                }
            </div>
            <div className="w-100 p-2">
    <button className="btn btn-lg btn-outline-success" onClick={() => openPopup(null, saveItem)}>Add Page</button>
    </div>
            </div>
        }
        
    }
    return <AppWrapper>
        <div className="w-100 p-1">
            <span className="me-3"><b>Page</b> </span>
           
        {
            ["all", ...config.pages].map(function(v, i){
                let active = "";
                if(page === "") {
                    if(i === 0) {
                        active = "active";
                    }
                }
                else {
                    if(v === page) {
                        active = "active";
                    }
                }
                return <a className={`btn btn-outline-secondary btn-sm me-2 ${active}`} onClick={() => setPage(v === "all"?"":v)}>{v}</a>
            })
        }
        </div>
        <div className="w-100 p-1">
            <span className="me-3"><b>Category</b> </span>
            {
            ["all", ...config.categories.map(function(v){
                return v.folder;
            }), ...config.newCategories.map(function(v){
                return v.slug;
            })].map(function(v, i){
                let active = "";
                if(type === "") {
                    if(i === 0) {
                        active = "active";
                    }
                }
                else {
                    if(v === type) {
                        active = "active";
                    }
                }
                return <a className={`btn btn-outline-secondary btn-sm m-1 ${active}`} onClick={() => setType(v === "all"?"":v)}>{v}</a>
            })
        }
            
        </div>
     {html}
    </AppWrapper>
}